import React from 'react';

import Typography from '../../library/typography/typography';
import { CheckSolidIcon } from '../../shared/icons/icons';

import { useMessage } from '../../shared/hooks/hooks';

import { FITMENT_OTHER_VEHICLES_OE_MESSAGE } from '../../shared/constants/messages';

import './product-oe-compatible.scss';

interface ProductOECompatibleProps {
  className?: string;
}

function ProductOECompatible(props: ProductOECompatibleProps) {
  const { className = '' } = props;
  const message =
    useMessage?.[FITMENT_OTHER_VEHICLES_OE_MESSAGE] ??
    '<strong>Compatible.</strong> This is an Original Equipment Tire for another vehicle but will fit yours!';
  return (
    <div className={`${className} product-oe-compatible`} styleName="content">
      <div className="product-oe-compatible__block" styleName="block">
        <CheckSolidIcon
          className="product-oe-compatible__icon"
          styleName="icon"
        />
        <Typography
          className="product-oe-compatible__label"
          dangerouslySetInnerHTML={{ __html: message }}
          styleName="label"
        />
      </div>
    </div>
  );
}

export default ProductOECompatible;
